import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

const StyledBox = styled(Box)(({ theme }) => ({
  '& .MLLDistrictAccordion': {
    boxShadow: 'none',
    color: theme.palette.common.white,
    backgroundColor: 'unset',
    backgroundImage: 'unset',
    paddingBottom: theme.spacing(4),
    '&.MLLInternational': {
      backgroundColor: theme.palette.background.secondary,
      '&.MLRemoveBg': {
        backgroundColor: 'unset',
      },
      '& .MLSummary': {
        paddingTop: theme.spacing(4),
      },
    },
  },
  '& .MLSummary': {
    '& .MuiAccordionSummary-content': {
      margin: theme.spacing(4, 0, 4, 0),
    },
  },
}));

export default StyledBox;
